/* eslint-disable import/no-cycle */
import React from "react";

import { useHistory } from "react-router-dom";

import { Dialog } from "primereact";
import Lottie from "react-lottie";

import BackButtom from "../../../../components/backButton";
import FormFactory from "../../../../components/form-factory";
import ResumeInvoice from "../../../../components/resume-invoice";
import { Fields } from "./fields";

import { DeveloperCompanyModel } from "../../../../../domain/models/developer-company.model";
import { Currencyprops } from "../../../../../domain/models/invoice";

import { theme } from "../../../../styles/theme";
import { CardContent, Wrapper } from "./styles";

import * as animationData from "../../../../assets/animations/loading.json";
import { makeRemoteInvoice } from "../../../../../main/factories/usecases/invoice/remote-invoice-factory";

const isSmallScreen = window.innerWidth < 768;

type PageProps = {
  loading: boolean;
  handleSubmit: (values: any, setShowConfirm: any) => Promise<void>;
  developerCompaniesList: DeveloperCompanyModel[];
};

const InvoiceForm: React.FC<PageProps> = ({
  loading,
  handleSubmit,
  developerCompaniesList,
}) => {
  const history = useHistory();

  const [currencies, setCurrencies] = React.useState<Currencyprops[]>([]);
  const [currentNote, setCurrentNote] = React.useState<any>();
  const [showResume, setShowResume] = React.useState<boolean>(false);
  const [showConfirm, setShowConfirm] = React.useState<boolean>(false);

  React.useEffect(() => {
    (async () => {
      try {
        const list = await makeRemoteInvoice().currency();
        setCurrencies(list || []);
      } catch (error) {
        setCurrencies([]);
      }
    })();
  }, []);

  const handleAddNote = async (values: any, actions: any): Promise<void> => {
    try {
      const selectedCompany = developerCompaniesList.find(
        (item) => item.id === Number(values.company),
      );
      const currencyObj = currencies.find(
        (item) => item.id === Number(values.currency),
      );
      const currencyString = currencyObj
        ? `${currencyObj.name} - ${currencyObj.code} - ${currencyObj.symbol}`
        : "";

      setCurrentNote({
        ...values,
        address: values.addressName,
        country: { name: values.nation },
        description: values.serviceDescription,
        currency: currencyString,
        currencyId: currencyObj?.id,
        developerCompany: selectedCompany?.company,
      });
      setShowResume(true);
    } catch (error) {
      console.error("Erro ao submeter o formulário:", error);
    } finally {
      actions.setSubmitting(false);
    }
  };

  const groups = Fields(developerCompaniesList, currencies, currentNote);

  return (
    <Wrapper>
      <BackButtom text="Emitir Invoice" />
      <CardContent style={{ position: "relative" }}>
        {loading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              zIndex: 9999,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "8px",
            }}
          >
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData,
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
              height={50}
              width={150}
            />
          </div>
        )}
        <FormFactory
          groups={groups}
          enbaleCountGroup
          onSubmit={handleAddNote}
          backButton={{
            submit: "Voltar",
            submitting: "Voltando...",
            hide: false,
            onClick: () => history.goBack(),
            backgroundColor: theme.colors.darkBlue,
          }}
          button={{
            submit: "Gerar Invoice",
            submitting: "Gerando...",
            hide: false,
            backgroundColor: theme.colors.blue400,
          }}
        />
      </CardContent>
      <Dialog
        header="Resumo do Invoice:"
        visible={showResume}
        style={{
          width: window.innerWidth < 479 ? "90vw" : "50vw",
          backgroundColor: theme.colors.darkBlue,
        }}
        headerStyle={{
          backgroundColor: theme.colors.darkBlue,
          color: theme.colors.white,
        }}
        contentStyle={{
          backgroundColor: theme.colors.darkBlue,
        }}
        footer={null}
        onHide={() => setShowResume(false)}
      >
        <ResumeInvoice
          invoice={currentNote}
          onConfirmCallback={async () => {
            await handleSubmit(currentNote, setShowConfirm);
          }}
          onCancelCallback={() => setShowResume(false)}
        />
      </Dialog>
      <Dialog
        header="Aguarde!"
        visible={showConfirm}
        headerStyle={{
          backgroundColor: theme.colors.darkBlue,
          color: theme.colors.white,
          fontFamily: theme.font.poppins,
        }}
        style={{
          width: isSmallScreen ? "90vw" : "35vw",
          backgroundColor: theme.colors.darkBlue,
          color: theme.colors.white,
          fontFamily: theme.font.poppins,
        }}
        contentStyle={{
          backgroundColor: theme.colors.darkBlue,
          color: theme.colors.white,
          fontFamily: theme.font.poppins,
        }}
        footer={null}
        onHide={() => null}
        closable={false}
      >
        <Lottie
          options={{
            loop: true,
            autoplay: true,
            animationData,
            rendererSettings: {
              preserveAspectRatio: "xMidYMid slice",
            },
          }}
          height={20}
          width={100}
          isStopped={false}
          isPaused={false}
        />
        <p className="text-center mt-4" style={{ maxWidth: "100%" }}>
          Invoice sendo gerado. Você será redirecionado para a tela de listagem
          onde poderá fazer o download do documento.
        </p>
      </Dialog>
    </Wrapper>
  );
};
export default InvoiceForm;
